var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('KTPortlet',_vm._b({scopedSlots:_vm._u([{key:"toolbar",fn:function(){return undefined},proxy:true},{key:"body",fn:function(){return [_c('table',{staticClass:"table"},[_c('tbody',_vm._l((_vm.model.claims),function(obj,key,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(obj.claim))]),_c('td',[_vm._v(_vm._s(obj.value))])])}),0)])]},proxy:true}])},'KTPortlet',{
        title: 'Profile',
        class: 'kt-portlet--head-noborder',
        headNoBorder: true
      },false))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }